/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchExperienceByTimeOfDayParams {
  time_of_day: string;
}

export const sendGAWabunkaSearchExperienceByTimeOfDayEvent = (timeOfDay: string) => {
  if (timeOfDay === '') {
    return;
  }
  sendWabunkaGAEvent('search_experience_by_time_of_day', { time_of_day: timeOfDay });
};
